import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarFloating: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSidebarFloating"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4V20H2V4H22ZM14 10V16H18V10H14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarFloating;
